import { BasePaper } from "@/shared/ui/base-paper";
import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

type Props = {
  items: {
    label: string;
    cargo: React.ReactNode;
    proposal: React.ReactNode;
  }[];
};

const tableCellStyles = { px: 2, py: 1.5, verticalAlign: "top" } as const;

export const MobileDeliveryProposalFormTable = ({ items }: Props) => {
  return (
    <Stack spacing={1}>
      {items.map((item) => (
        <TableContainer component={BasePaper} key={item.label}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell colSpan={2} sx={{ ...tableCellStyles }}>
                  {item.label}
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <TableCell
                  sx={{
                    ...tableCellStyles,
                    borderRight: "1px solid #E0E0E0",
                    minWidth: 128,
                    width: 128,
                  }}
                >
                  {item.cargo ?? "-"}
                </TableCell>
                <TableCell sx={{ ...tableCellStyles }}>
                  {item.proposal && (
                    <>
                      <Typography fontSize={14} fontWeight={500} mb={0.5}>
                        提案内容:
                      </Typography>
                      {item.proposal}
                    </>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      ))}
    </Stack>
  );
};
